import type { Icon } from '../../../src/lib/types'
export const mdiArrowRightBottom: Icon = {
  "id": "arrow-right-bottom",
  "name": "Arrow Right Bottom",
  "path": "M20 16L14.5 21.5L13.08 20.09L16.17 17H10.5C6.91 17 4 14.09 4 10.5V4H6V10.5C6 13 8 15 10.5 15H16.17L13.09 11.91L14.5 10.5L20 16Z",
  "as": [],
  "tags": []
}
export default mdiArrowRightBottom